import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './AAC.css';

const AAC = () => {
  const [modalOpen, setModalOpen] = useState(false);

  const formule = {
    heures: '20',
    prestations: [
      'Prise en charge complète du dossier administratif (création NEPH, démarches préfectorales, rendez-vous)',
      'Accès illimité à la salle de code avec livre de code inclus',
      '20 leçons de conduite dont 4 sur simulateur pour maîtriser les fondamentaux en toute sécurité (volant, boîte de vitesses, pédales)',
      'Rendez-vous préalable de 2 heures minimum avant la conduite accompagnée',
      'Assurance garantie financière',
      'Kit pédagogique complet (livret d\'apprentissage, fiche de suivi, livret d\'interrogation orale)',
      'Redevance ETG',
      'Présence d\'un enseignant diplômé lors de l\'examen pratique',
      'Application mobile pour suivre votre progression en temps réel',
      'Premier rendez-vous pédagogique (minimum 1500 km parcourus - 3 heures)',
      'Deuxième rendez-vous pédagogique (minimum 1500 km parcourus - 3 heures)'
    ],
    complementaires: [
      'Bilan de compétences initial'
    ],
    prix: 1300
  };

  const avantages = [
    {
      icon: '🎓',
      title: 'Formation dès 15 ans',
      description: 'Commencez votre apprentissage plus tôt pour être prêt dès 17 ans'
    },
    {
      icon: '💰',
      title: 'Économies sur l\'assurance',
      description: 'Bénéficiez de tarifs préférentiels et de surprimes réduites après l\'obtention du permis'
    },
    {
      icon: '⏱️',
      title: 'Permis probatoire réduit',
      description: 'Passez de 3 à 2 ans de période probatoire grâce à la conduite accompagnée'
    },
    {
      icon: '🛡️',
      title: 'Expérience renforcée',
      description: '3000 km minimum au volant pour une confiance et une sécurité accrues'
    },
    {
      icon: '👨‍👩‍👧',
      title: 'Apprentissage en famille',
      description: 'Profitez du soutien de vos proches comme accompagnateurs qualifiés'
    }
  ];

  const etapes = [
    {
      numero: '1',
      titre: 'Évaluation et code',
      description: 'Bilan initial de vos compétences puis formation au code de la route'
    },
    {
      numero: '2',
      titre: 'Apprentissage pratique',
      description: '20 heures de conduite avec simulateur pour maîtriser les bases'
    },
    {
      numero: '3',
      titre: 'Conduite accompagnée',
      description: '1 an minimum avec vos accompagnateurs sur au moins 3000 km'
    },
    {
      numero: '4',
      titre: 'Suivi pédagogique',
      description: 'Rendez-vous réguliers pour évaluer votre progression'
    },
    {
      numero: '5',
      titre: 'Examen final',
      description: 'Passez votre permis dès 17 ans avec une meilleure préparation'
    }
  ];

  const documentsRequis = [
    'Pièce d\'identité recto-verso',
    'Justificatif de domicile de moins de 3 mois',
    'Document de recensement (si moins de 17 ans) ou attestation JDC',
    'Photos numériques aux normes ANTS',
    'Permis AM (BSR) si vous en êtes titulaire',
    'Livret de famille',
    'Enveloppe de suivi format A5'
  ];

  const conditionsAccompagnateurs = [
    'Permis B depuis au moins 5 ans sans interruption',
    'Accord de l\'assurance du véhicule',
    'Aucune condamnation pour délits routiers graves',
    'Mentionné sur l\'attestation de fin de formation'
  ];

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  return (
    <div className="aac-page">
      <section className="aac-hero">
        <div className="container">
          <div className="hero-content-aac">
            <h1 className="aac-title">Conduite Accompagnée</h1>
            <p className="aac-subtitle">Formez-vous dès 15 ans, passez votre permis à 17 ans</p>
            <p className="hero-description">
              L'apprentissage anticipé de la conduite vous permet de commencer votre formation plus tôt 
              et de gagner en confiance grâce à une expérience de conduite approfondie avec vos proches.
            </p>
          </div>
        </div>
      </section>

      {/* Section Avantages */}
      <section className="aac-avantages-section">
        <div className="container">
          <h2 className="section-title-main">Pourquoi choisir la conduite accompagnée ?</h2>
          <div className="avantages-grid-modern">
            {avantages.map((avantage, index) => (
              <div key={index} className="avantage-card-modern">
                <div className="avantage-icon-modern">{avantage.icon}</div>
                <h3 className="avantage-title-modern">{avantage.title}</h3>
                <p className="avantage-desc-modern">{avantage.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Section Formule */}
      <section className="aac-formule-section-modern">
        <div className="container">
          <div className="formule-container-modern">
            <div className="formule-header-modern">
              <span className="formule-badge-modern">Formule complète</span>
              <h2 className="formule-title-modern">20 Leçons avec Code</h2>
              <p className="formule-subtitle-modern">Tout inclus pour votre réussite</p>
            </div>

            <div className="formule-content-modern">
              <div className="prestations-main">
                <h3 className="prestations-header">Inclus dans la formule :</h3>
                <ul className="prestations-list-modern">
                  {formule.prestations.map((prestation, index) => (
                    <li key={index} className="prestation-item-modern">
                      <span className="check-icon">✓</span>
                      <span>{prestation}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="prestations-complement">
                <h3 className="prestations-header">Options disponibles :</h3>
                <ul className="prestations-list-modern">
                  {formule.complementaires.map((prestation, index) => (
                    <li key={index} className="prestation-item-modern option">
                      <span className="plus-icon">+</span>
                      <span>{prestation}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <button onClick={handleOpenModal} className="btn-formule-modern">
                Découvrir les tarifs
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Section Étapes */}
      <section className="aac-etapes-section">
        <div className="container">
          <h2 className="section-title-main">Votre parcours en 5 étapes</h2>
          <div className="etapes-timeline">
            {etapes.map((etape, index) => (
              <div key={index} className="etape-item">
                <div className="etape-numero">{etape.numero}</div>
                <div className="etape-content">
                  <h3 className="etape-titre">{etape.titre}</h3>
                  <p className="etape-description">{etape.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Section Documents et Conditions */}
      <section className="aac-info-section">
        <div className="container">
          <div className="info-grid">
            <div className="info-card">
              <h3 className="info-card-title">📋 Documents nécessaires</h3>
              <ul className="info-list">
                {documentsRequis.map((doc, index) => (
                  <li key={index} className="info-item">
                    <span className="bullet">•</span>
                    <span>{doc}</span>
                  </li>
                ))}
              </ul>
              <p className="info-note">
                Si vous êtes hébergé, ajoutez une attestation d'hébergement et la pièce d'identité de l'hébergeant.
              </p>
            </div>

            <div className="info-card">
              <h3 className="info-card-title">👥 Conditions pour les accompagnateurs</h3>
              <ul className="info-list">
                {conditionsAccompagnateurs.map((condition, index) => (
                  <li key={index} className="info-item">
                    <span className="bullet">•</span>
                    <span>{condition}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="aac-cta-section">
        <div className="container">
          <h2 className="cta-title">Prêt à commencer votre formation ?</h2>
          <p className="cta-description">Contactez-nous pour en savoir plus sur nos formules et tarifs</p>
          <Link to="/contact" className="btn-cta-main">
            Nous contacter
          </Link>
        </div>
      </section>

      {/* Modal Tarifs */}
      {modalOpen && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={handleCloseModal}>×</button>
            <h3 className="modal-title">Tarif - Formule 20 leçons</h3>
            <div className="modal-price">
              <p className="price-label">À partir de</p>
              <p className="price-amount">{formule.prix} €</p>
            </div>
            <p className="modal-description">
              Pour plus d'informations et connaître le tarif exact adapté à votre situation, 
              n'hésitez pas à nous contacter.
            </p>
            <Link to="/contact" className="btn btn-contact-modal">
              NOUS CONTACTER
            </Link>
          </div>
        </div>
      )}
    </div>
  );
};

export default AAC;
